
import { defineComponent, reactive, toRefs, watch, computed } from 'vue'
import tabList from '@/components/common/tab/tab-list.vue'
import { getCurTab } from '@/composables/use-function'
import customBtn from '@/components/common/btn/custom-btn.vue'
import dealerNewsList from '@/components/gold-dealer/dealer-news-list.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { fetchDealerNewsList, countAd } from '@/http/api'
import { setTxtLength } from '@/utils/handle-text'
export default defineComponent({
  name: '',
  props: ['columnImgUrl'],
  components: {
    tabList,
    customBtn,
    dealerNewsList,
  },
  emits: ['openCarSideBar'],
  setup(props, { emit }) {
    const store = useStore()
    const route = useRoute()
    const data = reactive({
      activityInfo: computed(() => store.state.activityInfo),
      locationInfo: computed(() => store.state.locationInfo),
      carInfo: computed(() => store.state.carInfo),
      queryObj: {
        actId: -1,
        brandId: -1,
        cityId: -1,
        pageNo: 1,
        pageSize: 3,
      },
      dealerNewsList: [] as any,
      total: 1,
      noResult: 1, // 是否查询无结果: 1-是,0-否
      isShowLoadMore: false,
      isShowLoading: true, // 数据加载loading
      curBrandTabIndex: 0,
    })
    // 定位信息
    watch(
      () => data.locationInfo,
      (nVal, oVal) => {
        if (nVal.cityId !== oVal.cityId) {
          data.queryObj.cityId = nVal.cityId
          data.queryObj.pageNo = 1
          data.dealerNewsList = []
          methods.getDealerNewsList(true)
        }
      },
    )
    // 活动信息
    watch(
      () => data.activityInfo,
      (nVal, oVal) => {
        if (nVal !== oVal && nVal.brands.length > 1) {
          data.queryObj.brandId = nVal.brands[1].brandId
          data.dealerNewsList = []
          methods.getDealerNewsList(true)
        }
      },
    )
    // 选车信息
    watch(
      () => data.carInfo,
      (nVal, oVal) => {
        if (nVal !== oVal) {
          data.queryObj.brandId = nVal.carBrand.id
          data.queryObj.pageNo = 1
          data.curBrandTabIndex = getCurTab(nVal.carBrand.id, brandList.value) // 修改当前tab
          data.dealerNewsList = []
          methods.getDealerNewsList(true)
        }
      },
    )
    const brandList = computed(() => {
      if (!data.activityInfo.brands) return
      // 不展示推荐
      let newBrandList = data.activityInfo.brands.map((brand: any) => {
        return {
          ...brand,
          type: 'brandList',
          showName: brand.brand,
        }
      })
      return newBrandList.slice(1)
    })
    const methods = {
      // 获取经销商行情列表
      async getDealerNewsList(isReGet: any = false) {
        if (
          !route.query.actId ||
          data.queryObj.brandId === -1 ||
          data.queryObj.cityId === -1 ||
          data.queryObj.brandId === -1
        ) {
          return
        }
        data.isShowLoading = true
        const res: any = await fetchDealerNewsList({
          actId: route.query.actId,
          brandId: data.queryObj.brandId,
          cityId: data.locationInfo.cityId,
          pageNo: data.queryObj.pageNo,
          pageSize: 3,
        })
        data.isShowLoading = false
        if (res.code === 200) {
          if (res.data.noResult === 1) {
            data.dealerNewsList = []
          } else {
            if (isReGet) {
              data.dealerNewsList = [].concat(res.data.list)
            } else {
              data.dealerNewsList = data.dealerNewsList.concat(res.data.list)
            }
          }
          data.dealerNewsList = data.dealerNewsList.map((item: any) => {
            item.dealerShortName = setTxtLength(item.dealerShortName, 8)
            item.businessBrand = setTxtLength(item.businessBrand, 8)
            item.dealerNewsTitle = setTxtLength(item.dealerNewsTitle, 12)
            return item
          })
          data.noResult = res.data.noResult
          data.total = res.data.total
        }
      },
      // 打开品牌侧边栏
      openCarSideBar() {
        emit('openCarSideBar', {
          name: 'gold-dealer',
        })
        countAd(6312)
      },
      // 修改tab
      changeTabItem(tabIndex: any, tabItem: any) {
        if (tabItem.type === 'brandList') {
          data.curBrandTabIndex = tabIndex
          data.queryObj.brandId = tabItem.brandId
          data.queryObj.pageNo = 1
          methods.getDealerNewsList(true)
        }
      },
      // 修改页码
      changePageNo() {
        data.queryObj.pageNo = data.queryObj.pageNo + 1
      },
      // 加载更多
      getMoreData() {
        data.queryObj.pageNo = data.queryObj.pageNo + 1
        methods.getDealerNewsList()
      },
    }
    return {
      ...toRefs(data),
      ...methods,
      brandList,
    }
  },
})
